/**
 * 10Duke End User Identity API
 * Authenticate user and manage authenticated sessions
 *
 * OpenAPI spec version: 2.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { CompleteCredentialRegistrationRequestOptions } from '../model/completeCredentialRegistrationRequestOptions';
import { CompleteCredentialRegistrationResponseOptions } from '../model/completeCredentialRegistrationResponseOptions';
import { DeleteCredentialRequestOptions } from '../model/deleteCredentialRequestOptions';
import { StartAuthenticationRequestOptions } from '../model/startAuthenticationRequestOptions';
import { StartAuthenticationResponseOptions } from '../model/startAuthenticationResponseOptions';
import { StartCredentialRegistrationRequestOptions } from '../model/startCredentialRegistrationRequestOptions';
import { StartCredentialRegistrationResponseOptions } from '../model/startCredentialRegistrationResponseOptions';
import { WebAuthnCredentialInfo } from '../model/webAuthnCredentialInfo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WebAuthnService {

    protected basePath = 'http://localhost:8080/api/v2';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Completes WebAuthn credential (passkey) registration process
     * Verifies WebAuthn [PublicKeyCredential](https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential) (passkey) and completes the credential registration process.&lt;br&gt;&lt;br&gt;The browser is expected to call &#x60;startCredentialRegistration&#x60; (&#x60;POST /webauthn/registrations/start&#x60; in this API) and [CredentialsContainer.create(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/create) before calling this operation, and supply the value returned by [CredentialsContainer.create(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/create) as the &#x60;publicKeyCredential&#x60; property value.
     * @param body Request to complete WebAuthn credential (passkey) registration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public completeCredentialRegistration(body: CompleteCredentialRegistrationRequestOptions, observe?: 'body', reportProgress?: boolean): Observable<CompleteCredentialRegistrationResponseOptions>;
    public completeCredentialRegistration(body: CompleteCredentialRegistrationRequestOptions, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CompleteCredentialRegistrationResponseOptions>>;
    public completeCredentialRegistration(body: CompleteCredentialRegistrationRequestOptions, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CompleteCredentialRegistrationResponseOptions>>;
    public completeCredentialRegistration(body: CompleteCredentialRegistrationRequestOptions, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling completeCredentialRegistration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CompleteCredentialRegistrationResponseOptions>('post',`${this.basePath}/webauthn/registrations`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a WebAuthn credential (passkey)
     * Deletes a WebAuthn credential (passkey) registered for the currently authenticated user.
     * @param body 
     * @param credentialObjId Unique id of the registered WebAuthn credential (passkey) object
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWebAuthnCredentials(body: DeleteCredentialRequestOptions, credentialObjId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteWebAuthnCredentials(body: DeleteCredentialRequestOptions, credentialObjId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteWebAuthnCredentials(body: DeleteCredentialRequestOptions, credentialObjId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteWebAuthnCredentials(body: DeleteCredentialRequestOptions, credentialObjId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteWebAuthnCredentials.');
        }

        if (credentialObjId === null || credentialObjId === undefined) {
            throw new Error('Required parameter credentialObjId was null or undefined when calling deleteWebAuthnCredentials.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/webauthn/registrations/${encodeURIComponent(String(credentialObjId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lists user&#x27;s WebAuthn credentials (passkeys)
     * Lists WebAuthn credentials (passkeys) registered for the currently authenticated user.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listWebAuthnCredentials(observe?: 'body', reportProgress?: boolean): Observable<Array<WebAuthnCredentialInfo>>;
    public listWebAuthnCredentials(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WebAuthnCredentialInfo>>>;
    public listWebAuthnCredentials(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WebAuthnCredentialInfo>>>;
    public listWebAuthnCredentials(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<WebAuthnCredentialInfo>>('get',`${this.basePath}/webauthn/registrations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Starts WebAuthn (passkey) authentication process
     * Starts process for authenticating user with a WebAuthn credential (passkey).&lt;br&gt;&lt;br&gt;The browser is expected to call this operation before calling [CredentialsContainer.get(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/get), and use the returned &#x60;publicKeyCredentialRequestOptions&#x60; as the &#x60;options&#x60; argument for [CredentialsContainer.get(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/get).&lt;br&gt;&lt;br&gt;After calling [CredentialsContainer.get(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/get), the browser is expected to call &#x60;addAuthentications&#x60; (&#x60;POST /sessions/authentications&#x60; in this API) using the value returned by [CredentialsContainer.get(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/get) as the &#x60;publicKeyCredential&#x60; credential property value.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startAuthentication(body: StartAuthenticationRequestOptions, observe?: 'body', reportProgress?: boolean): Observable<StartAuthenticationResponseOptions>;
    public startAuthentication(body: StartAuthenticationRequestOptions, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StartAuthenticationResponseOptions>>;
    public startAuthentication(body: StartAuthenticationRequestOptions, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StartAuthenticationResponseOptions>>;
    public startAuthentication(body: StartAuthenticationRequestOptions, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling startAuthentication.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<StartAuthenticationResponseOptions>('post',`${this.basePath}/webauthn/authentications/start`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Starts WebAuthn credential (passkey) registration process
     * Starts process for creating and registering a new WebAuthn credential (passkey). A new credential can be created for a new user or for an existing user.&lt;br&gt;&lt;br&gt;The browser is expected to call this operation before calling [CredentialsContainer.create(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/create), and use the returned &#x60;publicKeyCredentialCreationOptions&#x60; as the &#x60;options&#x60; argument for [CredentialsContainer.create(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/create).&lt;br&gt;&lt;br&gt;After calling [CredentialsContainer.create(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/create), the browser is expected to call &#x60;completeCredentialRegistration&#x60; (&#x60;POST /webauthn/registrations&#x60; in this API) using the value returned by [CredentialsContainer.create(options)](https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/create) as the &#x60;publicKeyCredential&#x60; property value.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startCredentialRegistration(body: StartCredentialRegistrationRequestOptions, observe?: 'body', reportProgress?: boolean): Observable<StartCredentialRegistrationResponseOptions>;
    public startCredentialRegistration(body: StartCredentialRegistrationRequestOptions, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StartCredentialRegistrationResponseOptions>>;
    public startCredentialRegistration(body: StartCredentialRegistrationRequestOptions, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StartCredentialRegistrationResponseOptions>>;
    public startCredentialRegistration(body: StartCredentialRegistrationRequestOptions, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling startCredentialRegistration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<StartCredentialRegistrationResponseOptions>('post',`${this.basePath}/webauthn/registrations/start`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
